import { getField, updateField } from 'vuex-map-fields';
import apiSheet from '@/services/api/sheet';
import apiGiftGivingReport from '@/services/api/giftGivingReport';
import HttpStatus from 'http-status-codes';

const defaultGiftGivingReportState = () => {
    return {
        packsAmount: null,
        giftGiverInfo: {
            consentForPhoto: null,
            giftGiverMetFamily: null,
            reasonForVisit: null,
            describeGiftGiver: null
        },
        familyReaction: null,
        packsContent: {
            isPackCorrespondsToNeeds: null,
            wasAbsent: null,
            packQuality: null,
            packQualityArguments: null,
            packItems: null,
            wereIntangibleNeeds: null,
            describeIntangibleNeeds: null
        },
        newMeetingWithFamily: null,
        planRepeatedMeeting: null,
        noRepeatedMeetingReason: null,
        deliveryReport: null,
        familyWords: null,
        familyWordNeed: null,
        volunteerWords: null
    };
};

export default {
    namespaced: true,
    state: {
        giftGivingReportState: defaultGiftGivingReportState(),
        sheetResource: null,
        loadGiftGivingReportData: null,
        hasDraft: null,
        giftGivingReportQuestions: null
    },
    getters: {
        getField,
        getGiftGivingReportState (state) {
            return getField(state.giftGivingReportState);
        },
        getGiftGiverInfo (state) {
            return getField(state.giftGivingReportState.giftGiverInfo);
        },
        getPacksContent (state) {
            return getField(state.giftGivingReportState.packsContent);
        },
        getSheetResource: (state) => state.sheetResource,
        returnGiftGivingReportState: (state) => state.giftGivingReportState,
        getLoadGiftGivingReportData: (state) => state.loadGiftGivingReportData,
        getHasDraft: (state) => state.hasDraft,
        giftGivingReportQuestions (state) {
            return state.giftGivingReportQuestions;
        }
    },
    mutations: {
        updateField,
        updateGiftGivingReportState (state, field) {
            updateField(state.giftGivingReportState, field);
        },
        updateGiftGiverInfo (state, field) {
            updateField(state.giftGivingReportState.giftGiverInfo, field);
        },
        updatePacksContent (state, field) {
            updateField(state.giftGivingReportState.packsContent, field);
        },
        setGiftGivingReportState (state, payload) {
            state.giftGivingReportState = payload;
        },
        clearGiftGivingReportState (state) {
            state.giftGivingReportState = defaultGiftGivingReportState();
        },
        setSheetResource (state, payload) {
            state.sheetResource = payload;
        },
        setLoadGiftGivingReportData (state, payload) {
            state.loadGiftGivingReportData = payload;
        },
        setHasDraft (state, payload) {
            state.hasDraft = payload;
        },
        setGiftGivingReportQuestions (state, payload) {
            state.giftGivingReportQuestions = payload;
        }
    },
    actions: {
        getSheetResource (context, payload) {
            return apiSheet.getResourceSheet(payload.sheetId, payload.editionName).then((data) => {
                context.commit('setSheetResource', data.data.data.sheet_resource);
            });
        },
        async getGiftGivingReport (context, id) {
            const status = await apiGiftGivingReport
                .getGiftGivingReport(id)
                .then((data) => {
                    context.commit('setLoadGiftGivingReportData', true);
                    const _data = data.data.data;
                    const _formattedData = {
                        packsAmount: _data.package_count,
                        giftGiverInfo: {
                            consentForPhoto: _data.photo_consent,
                            giftGiverMetFamily: _data.family_visited,
                            reasonForVisit: _data.reason_for_visit,
                            describeGiftGiver: _data.gift_giver_description
                        },
                        familyReaction: _data.family_response,
                        packsContent: {
                            isPackCorrespondsToNeeds: _data.key_needs,
                            wasAbsent: _data.key_needs_description,
                            packQuality: _data.quality,
                            packQualityArguments: _data.quality_description,
                            packItems: _data.content,
                            wereIntangibleNeeds: _data.immaterial_content,
                            describeIntangibleNeeds: _data.immaterial_content_description
                        },
                        newMeetingWithFamily: _data.repeated_meeting,
                        planRepeatedMeeting: _data.plan_repeated_meeting,
                        noRepeatedMeetingReason: _data.no_repeated_meeting_reason,
                        deliveryReport: _data.delivery_relation,
                        familyWords: _data.family_word,
                        familyWordNeed: _data.family_word_need,
                        volunteerWords: _data.volunteer_word
                    };
                    context.commit('setGiftGivingReportState', _formattedData);
                    context.commit('setGiftGivingReportQuestions', _data.gift_giving_report_questions);
                    return false;
                })
                .catch((e) => {
                    if (e.response.status === HttpStatus.NOT_FOUND) {
                        context.commit('setLoadGiftGivingReportData', false);
                        return true;
                    }
                });
            if (status === true) {
                const lastRequest = await apiGiftGivingReport.getGiftGivingReportDraft(id).then((data) => {
                    if (data.data.data != null) {
                        context.commit('setGiftGivingReportState', data.data.data);
                        context.commit('setHasDraft', true);
                    } else {
                        context.commit('setHasDraft', false);
                    }
                })
                    .catch((e) => {
                        if (e.response.status === HttpStatus.NOT_FOUND) {
                            return true;
                        }
                    });
                return lastRequest;
            }
        },
        createGiftGivingReportDraft (context, data) {
            return apiGiftGivingReport.createGiftGivingReportDraft(data).then(() => {
                context.commit('setHasDraft', true);
            });
        },
        removeGiftGivingReportDraft (context, id) {
            return apiGiftGivingReport.removeGiftGivingReportDraft(id);
        },
        preCreateGivingReport (context, id) {
            return apiGiftGivingReport.preCreateGivingReport(id);
        }
    }
};
